import Select from 'epn-ui/umd/dist/components/Select';

import clsx from 'clsx';
import useI18n from '@i18n';

import { IOffers } from '@components/pages/creatives/creatives.interface';

import BaseEmpty from '@components/base/BaseEmpty';

interface IFiltersProps {
    className: string;
    offers: IOffers[];
    offerId: string;
    onChange: (name: string, value: string) => void;
}

const Filters: React.FC<IFiltersProps> = ({ className = '', offers, offerId, onChange }) => {
    const { t } = useI18n('Common');

    const getValue = (options, optionId) => options.find(({ value }) => value === optionId) || null;

    const SelectFilter = (inputValue, option) =>
        option.label.toLowerCase().includes(inputValue.toLowerCase());

    return (
        <div className={clsx('flex flex-wrap justify-between', className)}>
            <div className="flex items-center w-full">
                <Select
                    id="CreativesOffersSelect"
                    value={getValue(offers, offerId)}
                    onChange={value => onChange('offerId', value)}
                    options={offers}
                    placeholder={t('All offers')}
                    className="w-full mr-4 min-w-[190px]"
                    notFoundContent={<BaseEmpty id="CreativesOffersSelect" />}
                    filterOption={SelectFilter}
                    showSearch
                />
            </div>
        </div>
    );
};

export default Filters;
